import React, { useState, useCallback, useMemo } from 'react'
import Guid from 'devextreme/core/guid'
import useApi from '../useApi'
import {IDataSourceTarificationPlanProps, IDataSourceVentilationPlanProps} from '../../models/ICustomCalendar'

const useLoadDataPlans = (IDPlanEntete:Guid) => {
    const { getData: getDataPlan } = useApi()
    const [dataHorsService, setDataHorsService] = useState<any>();
    const [dataVentilation, setDataVentilation] = useState<IDataSourceVentilationPlanProps[]>([]);
    const [dataTarification, setDataTarification] = useState<IDataSourceTarificationPlanProps>();

    const _loadData = async () => {
        await Promise.all([
            getDataTarification(IDPlanEntete),
            getDataVentilation(IDPlanEntete),
            getDataHorsService(IDPlanEntete)
        ])
    }

    const getDataTarification =useCallback(async (IDPlanEntete:Guid) => {
        try {
            const response = await getDataPlan({customPath: `PlanDetailTarif/Tarification/${IDPlanEntete}`})
            if(!response || response === '')
                throw new Error("Quelque chose a mal tourne");
            const convertData = response as IDataSourceTarificationPlanProps
            setDataTarification(convertData);
            return convertData;
        } catch (error) {
            console.log('error in getDataTarification', error);
            return null
        }
    },[IDPlanEntete])

    const getDataVentilation =useCallback( async (IDPlanEntete:Guid) => {
        try {
            const response = await getDataPlan({customPath: `PlanVentilation/PlanVentilation/${IDPlanEntete}`})
            if(!response || response === '')
                throw new Error("Quelque chose a mal tourne");
            const convertData = response as IDataSourceVentilationPlanProps[]
            setDataVentilation(convertData)
            return convertData
        } catch (error) {
            console.log('error in getVentilation', error);
            return null
        }
    },[IDPlanEntete])

    const getDataHorsService =useCallback( async (IDPlanEntete:Guid) => {
        try {
            const response = await getDataPlan({customPath: `PlanEnteteHorsService/PlanHorsServiceDisponibilite/${IDPlanEntete}`})
            if(!response || response === '')
                throw new Error("Quelque chose a mal tourne");
            setDataHorsService(response);
            return response;
        } catch (error) {
            console.log('error in getDataHorsService', error);
            return null
        }
    },[IDPlanEntete])

    return {
        dataHorsService,
        dataVentilation,
        dataTarification,
        getDataVentilation,
        getDataHorsService,
        getDataTarification,
        _loadData
    }

}

export default useLoadDataPlans